<template>
  <div class="aboutPageContainer row">
    <VaultAbout v-if="aboutPageType === 'vault'" />
    <MarketplaceAbout v-else-if="aboutPageType === 'marketplace'" />
    <SingleMarketplaceAbout v-else-if="aboutPageType === 'single-marketplace'" />
    <AboutAuthenticators v-else-if="aboutPageType === 'about-authenticators'" />
  </div>
</template>


<script>
import AboutAuthenticators from './AboutAuthenticators.vue';
import MarketplaceAbout from './MarketplaceAbout.vue';
import SingleMarketplaceAbout from './SingleMarketplaceAbout.vue';
import VaultAbout from './VaultAbout.vue';

export default {
  name: 'AboutPage',
  components: {
    AboutAuthenticators,
    MarketplaceAbout,
    SingleMarketplaceAbout,
    VaultAbout,
  },
  data() {
    return {
      aboutPageType: jsConfig.aboutPageType
    };
  }
};
</script>
